import type { Signal } from "@suse-o11y/signal";
import { createContext } from "react";

import type { ExplorationDrawerState, ExplorationDrawerTable } from "./ExplorationDrawerState";

export interface ExplorationDrawerStateContextValue {
	drawers: Signal<ReadonlyArray<ExplorationDrawerTable>>;
	state: ExplorationDrawerState;
}

export const ExplorationDrawerStateContext = createContext<null | ExplorationDrawerStateContextValue>(null);
